<template>
    <div class="window">
        <div class="top-bar">
            <div class="circle" />
            <div class="circle" />
            <div class="circle" />
        </div>
        <div class="content">
            <slot />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'base-window',
    };
</script>

<style lang="scss" scoped>
    .window {
        border: 5px solid $purple;
        background: rgba(#f9f9f9, 0.8);

        .top-bar {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding: 10px 20px;
            border-bottom: 5px solid $purple;

            .circle {
                height: 15px;
                width: 15px;
                background: $purple;
                border-radius: 50%;

                &:not(:last-of-type) {
                    margin-right: 10px;
                }
            }
        }

        .content {
            margin-bottom: -3px;
            position: relative;
        }
    }
</style>
